import './agent-add-multi-item/agent-add-multi-item.component';
import './agent-add-multi-item/agent-add-multi-item.scss';

import './agent-allocation-binding-select/agent-allocation-binding-select.component';
import './agent-allocation-binding-select/agent-allocation-binding-select.scss';

import './agent-app-features/agent-app-features.component';
import './agent-app-features/agent-app-features.scss';

import './agent-assign-swap-table/agent-assign-swap-table.component';
import './agent-assign-swap-table/agent-assign-swap-table.scss';

import './agent-assign-swap-table-row/agent-assign-swap-table-row.component';
import './agent-assign-swap-table-row/agent-assign-swap-table-row.scss';

import './agents-assign-table/agents-assign-table.component';
import './agents-assign-table/agents-assign-table.scss';

import './agent-assign-table-row/agent-assign-table-row.component';
import './agent-assign-table-row/agent-assign-table-row.scss';

import './agent-assistant-mode/agent-assistant-mode.component';
import './agent-assistant-mode/agent-assistant-mode.scss';

import './agent-autocomplete/agent-autocomplete.component';
import './agent-autocomplete/agent-autocomplete.scss';

import './agent-avatar/agent-avatar.component';
import './agent-avatar/agent-avatar.scss';

import './agent-branches/agent-branches.component';
import './agent-branches/agent-branches.scss';

import './agent-create-button/agent-create-button.component';
import './agent-create-button/agent-create-button.scss';

import './agent-delivery-active/agent-delivery-active.component';
import './agent-delivery-active/agent-delivery-active.scss';

import './agent-delivery-history/agent-delivery-history.component';
import './agent-delivery-history/agent-delivery-history.scss';

import './agent-detailed-view/agent-detailed-view.component';
import './agent-detailed-view/agent-detailed-view.scss';

import './agent-documents-and-reminders/agent-documents-and-reminders.component'
import './agent-documents-and-reminders/agent-documents-and-reminders.scss'

import './agent-icon/agent-icon.component';
import './agent-icon/agent-icon.scss';

import './agent-info/agent-info.component';
import './agent-info/agent-info.scss';

import './agent-inventory-transactions-view/agent-inventory-transactions-view.component';
import './agent-inventory-transactions-view/agent-inventory-transactions-view.scss';

import './agent-itinerary-edit-mode/agent-itinerary-edit-mode.component';
import './agent-itinerary-edit-mode/agent-itinerary-edit-mode.scss';

import './agent-itinerary-link/agent-itinerary-link.component';
import './agent-itinerary-link/agent-itinerary-link.scss';

import './agent-itinerary-panel/agent-itinerary-panel.component';
import './agent-itinerary-panel/agent-itinerary-panel.scss';

import './agent-itinerary-print-page/agent-itinerary-print-page.component';
import './agent-itinerary-print-page/agent-itinerary-print-page.scss';

import './agent-itinerary-task-list/agent-itinerary-task-list.component';
import './agent-itinerary-task-list/agent-itinerary-task-list.scss';

import './agent-itinerary-tasks/agent-itinerary-tasks.component';
import './agent-itinerary-tasks/agent-itinerary-tasks.scss';

import './agent-itinerary-timeline/agent-itinerary-timeline.component';
import './agent-itinerary-timeline/agent-itinerary-timeline.scss';

import './agent-itinerary-view/agent-itinerary-view.component';
import './agent-itinerary-view/agent-itinerary-view.scss';

import './agent-link/agent-link.component';
import './agent-link/agent-link.scss';

import './agent-link-tooltip/agent-link-tooltip.component';
import './agent-link-tooltip/agent-link-tooltip.scss';

import './agent-list/agent-list.component';
import './agent-list/agent-list.scss';

import './agent-list-item/agent-list-item.component';
import './agent-list-item/agent-list-item.scss';

import './agent-list-itineraries-item/agent-list-itineraries-item.component';
import './agent-list-itineraries-item/agent-list-itineraries-item.scss';

import './agent-list-itineraries-section/agent-list-itineraries-section.component';
import './agent-list-itineraries-section/agent-list-itineraries-section.scss';

import './agent-location/agent-location.component';
import './agent-location/agent-location.scss';

import './agent-locations-view/agent-locations-view.component';

import './agents-multi-select/agents-multi-select.component';
import './agents-multi-select/agents-multi-select.scss';

import './agent-multi-select-list/agent-multi-select-list.component';
import './agent-multi-select-list/agent-multi-select-list.scss';

import './agent-multiple-skill-select/agent-multiple-skill-select.component';
import './agent-multiple-skill-select/agent-multiple-skill-select.scss';

import './agent-packages-print-page/agent-packages-print-page.component';
import './agent-packages-print-page/agent-packages-print-page.scss';

import './agent-preferences/agent-preferences.component';
import './agent-preferences/agent-preferences.scss';

import './agent-preferences-panel/agent-preferences-panel.component';
import './agent-preferences-panel/agent-preferences-panel.scss';

import './agent-profile/agent-profile.component';
import './agent-profile/agent-profile.scss';

import './agent-registration-status/agent-registration-status.component';
import './agent-registration-status/agent-registration-status.scss';

import './agent-requirement-status/agent-requirement-status.component';
import './agent-requirement-status/agent-requirement-status.scss';

import './agent-requirement-view/agent-requirement-view.component';
import './agent-requirement-view/agent-requirement-view.scss';

import './agent-requirements-icon/agent-requirements-icon.component';
import './agent-requirements-icon/agent-requirements-icon.scss';

import './agent-requirements-progress-list/agent-requirements-progress-list.component';
import './agent-requirements-progress-list/agent-requirements-progress-list.scss';

import './agent-routes-dialog-view/agent-routes-dialog-view.component';
import './agent-routes-dialog-view/agent-routes-dialog-view.scss';

import './agent-requirements/agent-requirements.component';
import './agent-requirements/agent-requirements.scss';

import './agent-schedule-import-view/agent-schedule-import-view.component';
import './agent-schedule-import-view/agent-schedule-import-view.scss';

import './agent-schedule-view/agent-schedule-view.component';
import './agent-schedule-view/agent-schedule-view.scss';

import './agent-select/agent-select.component';
import './agent-select/agent-select.scss';

import './agent-service-areas/agent-service-areas.component';

import './agent-shift-form/agent-shift-form.component';
import './agent-shift-form/agent-shift-form.scss';

import './agent-shift-panel/agent-shift-panel.component';
import './agent-shift-panel/agent-shift-panel.scss';

import './agent-shift-timeline-logs/agent-shift-timeline-logs.component';

import './agent-skills-display-list/agent-skills-display-list.component';
import './agent-skills-display-list/agent-skills-display-list.scss';

import './agent-skills-multi-select-list/agent-skills-multi-select-list.component';
import './agent-skills-multi-select-list/agent-skills-multi-select-list.scss';

import './agent-status-select-list/agent-status-select-list.component';
import './agent-status-select-list/agent-status-select-list.scss';

import './agent-type-multiple-select-section/agent-type-multiple-select-section.component';
import './agent-type-multiple-select-section/agent-type-multiple-select-section.scss';

import './agent-type-select/agent-type-select.component';
import './agent-type-select/agent-type-select.scss';

import './agent-type-select-list/agent-type-select-list.component';
import './agent-type-select-list/agent-type-select-list.scss';

import './agent-vehicles-view/agent-vehicles-view.component';
import './agent-vehicles-view/agent-vehicles-view.scss';

import './agent-working-slots/agent-working-slots.component';
import './agent-working-slots/agent-working-slots.scss';

import './agents-autocomplete/agents-autocomplete.component';
import './agents-autocomplete/agents-autocomplete.scss';

import './agents-display-list/agents-display-list.component';
import './agents-display-list/agents-display-list.scss';

import './agents-filter-status-select/agents-filter-status-select.component';
import './agents-filter-status-select/agents-filter-status-select.scss';

import './agents-groups-nav-bar/agents-groups-nav-bar.component';
import './agents-groups-nav-bar/agents-groups-nav-bar.scss';

import './agents-indicator/agents-indicator.component';
import './agents-indicator/agents-indicator.scss';

import './agents-itineraries-list-view/agents-itineraries-list-view.component';
import './agents-itineraries-list-view/agents-itineraries-list-view.scss';

import './agents-itineraries-timeline-view/agents-itineraries-timeline-view.component';
import './agents-itineraries-timeline-view/agents-itineraries-timeline-view.scss';

import './agents-itineraries-view/agents-itineraries-view.component';
import './agents-itineraries-view/agents-itineraries-view.scss';

import './agents-list-view/agents-list-view.component';
import './agents-list-view/agents-list-view.scss';

import './agents-payment-transactions-view/agents-payment-transactions-view.component';
import './agents-payment-transactions-view/agents-payment-transactions-view.scss';

import './agents-payment-transactions-table/agents-payment-transactions-table.component';
import './agents-payment-transactions-table/agents-payment-transactions-table.scss';

import './agents-payment-transactions-table-row/agents-payment-transactions-table-row.component';
import './agents-payment-transactions-table-row/agents-payment-transactions-table-row.scss';

import './agents-pending-list-view/agents-pending-list-view.component';
import './agents-pending-list-view/agents-pending-list-view.scss';

import './agents-schedule-timeline-new/agents-schedule-timeline-new.component';
import './agents-schedule-timeline-new/agents-schedule-timeline-new.scss';

import './agents-schedule-timeline-beta/agents-schedule-timeline-beta.component';
import './agents-schedule-timeline-beta/agents-schedule-timeline-beta.scss';

import './agents-schedule-view-new/agents-schedule-view-new.component';
import './agents-schedule-view-new/agents-schedule-view-new.scss';

import './agents-schedule-view-beta/agents-schedule-view-beta.component';
import './agents-schedule-view-beta/agents-schedule-view-beta.scss';

import './agents-shift-management-view-new/agents-shift-management-view-new.component';
import './agents-shift-management-view-new/agents-shift-management-view-new.scss';

import './agents-shift-management-timeline-new/agents-shift-management-timeline-new.component';
import './agents-shift-management-timeline-new/agents-shift-management-timeline-new.scss';

import './agents-table/agents-table.component';
import './agents-table/agents-table.scss';

import './agents-table-row/agents-table-row.component';
import './agents-table-row/agents-table-row.scss';

import './agents-radio-table/agents-radio-table.component';
import './agents-radio-table/agents-radio-table.scss';

import './agents-radio-table-row/agents-radio-table-row.component';
import './agents-radio-table-row/agents-radio-table-row.scss';

import './agents-validation-table/agents-validation-table.component';
import './agents-validation-table/agents-validation-table.scss';

import './agents-validation-table-row/agents-validation-table-row.component';
import './agents-validation-table-row/agents-validation-table-row.scss';

import './create-agent-form/create-agent-form.component';
import './create-agent-form/create-agent-form.scss';

import './employment-type-select-list/employment-type-select-list.component';
import './employment-type-select-list/employment-type-select-list.scss';

import './itineraries-tasks-settings-panel/itineraries-tasks-settings-panel.component'
import './itineraries-tasks-settings-panel/itineraries-tasks-settings-panel.scss'


import './itinerary-tasks-action-menu/itinerary-tasks-action-menu.component';
import './itinerary-tasks-action-menu/itinerary-tasks-action-menu.scss';

import './select-verticals/select-verticals.component';

import './upload-agents-view/upload-agents-view.component';
import './upload-agents-view/upload-agents-view.scss';

import './agents-view-settings-panel/agents-view-settings-panel.component';
import './agents-view-settings-panel/agents-view-settings-panel.scss';

import './agents-view-settings-panel/agents-view-settings-panel-template/agents-view-settings-panel-template.component';
import './agents-view-settings-panel/agents-view-settings-panel-template/agents-view-settings-panel-template.scss';

import './agent-select-list/agent-select-list.component';
import './agent-select-list/agent-select-list.scss';

import './agent-gps-permission-multi-select-list/agent-gps-permission-multi-select-list.component';
import './agent-gps-permission-multi-select-list/agent-gps-permission-multi-select-list.scss';

import './agent-gps-permissions-display-list/agent-gps-permissions-display-list.component';
import './agent-gps-permissions-display-list/agent-gps-permissions-display-list.scss';

import './agent-tasks-view/agent-tasks-view.component';
import './agent-tasks-view/agent-tasks-view.scss';

import './agents-performance-view/agents-performance-view.component';
import './agents-performance-view/agents-performance-view.scss';

import './agent-performance-details/agent-performance-details.component';
import './agent-performance-details/agent-performance-details.scss';

import './agents-performance-timeline/agents-performance-timeline.component';
import './agents-performance-timeline/agents-performance-timeline.scss';

import './agent-itinerary-view-new/agent-itinerary-view-new.component';
import './agent-itinerary-view-new/agent-itinerary-view-new.scss';

import './agents-action-footer/agents-action-footer.component';
import './agents-action-footer/agents-action-footer.scss';

import './agent-assign-table-item/agent-assign-table-item.component';
import './agent-assign-table-item/agent-assign-table-item.scss';

import './agent-performance-task-card/agent-performance-task-card.component';
import './agent-performance-task-card/agent-performance-task-card.scss';

import './agent-route-report-tasks/agent-route-report-tasks.component';
import './agent-route-report-tasks/agent-route-report-tasks.scss';
